import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { updateSEO } from '../../../utils/seo';

// BTN-08 (light bg): navy fill + brass border + cream text -> hover brass fill + navy border.
const BTN08_ON_LIGHT = "relative inline-flex items-center justify-center bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#a38e65]/45 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#1a2942]/45";

export default function NewsEN() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortOrder, setSortOrder] = useState('desc');

  const breadcrumbs = [
    { label: 'Home', href: '/en' },
    { label: 'News & Updates' }
  ];

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'important', label: 'Important' },
    { id: 'report', label: 'Report' },
    { id: 'event', label: 'Event' },
    { id: 'industry', label: 'Industry Trends' },
    { id: 'technology', label: 'Technology' },
    { id: 'education', label: 'Education' }
  ];

  const newsItems = [
    { id: 1785533066131, title: "SABA International Butler Academy Highlights Fully Booked July 2026 Cape Town Hotel Butler Course", date: "2026-07-18", dateSort: "2026-07-18", category: 'industry', categoryLabel: 'Industry', link: "/en/news/saba-international-butler-academy-highlights-july-2026-cape-town-hotel" },

    { id: 1784434432791, title: "How Hospitality Shapes Exceptional Private Events in UK Households and Estates", date: "2026-06-30", dateSort: "2026-06-30", category: 'industry', categoryLabel: 'Industry', link: "/en/news/how-hospitality-shapes-exceptional-private-events" },

    { id: 1784434164495, title: "Beyond Childcare: The Expanding Role of the UHNW Nanny", date: "2026-07-09", dateSort: "2026-07-09", category: 'industry', categoryLabel: 'Industry', link: "/en/news/beyond-childcare-the-role-of-the-uhnw-nanny" },

    { id: 1784433961164, title: "Upskilling Redefines Overseas Private Household Roles", date: "2026-07-16", dateSort: "2026-07-16", category: 'industry', categoryLabel: 'Industry', link: "/en/news/how-upskilling-is-redefining-private-household-roles" },

    { id: 1, title: 'Raffles London "The Butler Did It" Campaign Chapter 2', date: 'September 17, 2025', dateSort: '2025-09-17', category: 'industry', categoryLabel: 'Industry', link: '/en/news/raffles-london-campaign' },
    { id: 2, title: 'Downton Abbey: The Grand Finale Movie Release', date: 'September 12, 2025', dateSort: '2025-09-12', category: 'event', categoryLabel: 'Event', link: '/en/news/downton-abbey-grand-finale' },
    { id: 3, title: 'Raffles Hotels & Resorts Global Brand Campaign "The Butler Did It"', date: 'September 10, 2024', dateSort: '2024-09-10', category: 'industry', categoryLabel: 'Industry', link: '/en/news/raffles-butler-campaign' },
    { id: 4, title: 'Apple Robot Butler Development Project Initiated', date: 'April 4, 2024', dateSort: '2024-04-04', category: 'technology', categoryLabel: 'Technology', link: '/en/news/apple-robot-butler' },
    { id: 5, title: 'Raffles Sentosa Luxury Escape Package (from SGD 4,985 per night)', date: 'October 15, 2025', dateSort: '2025-10-15', category: 'important', categoryLabel: 'Important', link: '/en/news/raffles-sentosa-butler-package' },
    { id: 6, title: 'AI Hospitality Revolution', date: 'August 14, 2025', dateSort: '2025-08-14', category: 'technology', categoryLabel: 'Technology', link: '/en/news/ai-hospitality-revolution' },
    { id: 7, title: 'Grant Harrold Royal Butler Memoir Published', date: 'August 1, 2025', dateSort: '2025-08-01', category: 'report', categoryLabel: 'Report', link: '/en/news/grant-harrold-royal-butler-memoir' },
    { id: 8, title: 'Swiss Ultra-Luxury Travel Boom (Private Ski Butler)', date: 'March 3, 2025', dateSort: '2025-03-03', category: 'industry', categoryLabel: 'Industry', link: '/en/news/swiss-luxury-travel-ski-butler' },
    { id: 9, title: 'Hong Kong Butler AI Achieves Profitability', date: 'February 1, 2025', dateSort: '2025-02-01', category: 'technology', categoryLabel: 'Technology', link: '/en/news/hong-kong-butler-ai-profitability' },
    { id: 10, title: 'TIBA Wins Global Award for Fifth Consecutive Year', date: 'December 20, 2024', dateSort: '2024-12-20', category: 'report', categoryLabel: 'Report', link: '/en/news/tiba-global-award-five-years' },
    { id: 11, title: 'China\'s Wealthy See Surge in Butler Demand', date: 'December 4, 2024', dateSort: '2024-12-04', category: 'industry', categoryLabel: 'Industry', link: '/en/news/china-butler-demand-surge' },
    { id: 12, title: 'Jumeirah Burj Al Arab 25th Anniversary', date: 'November 30, 2024', dateSort: '2024-11-30', category: 'event', categoryLabel: 'Event', link: '/en/news/jumeirah-burj-al-arab-25th-anniversary' },
    { id: 13, title: 'Global Butler Shortage Drives Salaries Above $130,000', date: 'October 15, 2024', dateSort: '2024-10-15', category: 'important', categoryLabel: 'Important', link: '/en/news/global-butler-shortage-salary-surge' },
    { id: 14, title: 'Weave Robotics Announces Isaac Home Robot Butler', date: 'September 9, 2024', dateSort: '2024-09-09', category: 'technology', categoryLabel: 'Technology', link: '/en/news/weave-robotics-isaac-robot-butler' }
  ];

  const filteredNews = selectedCategory === 'all'
    ? newsItems
    : newsItems.filter(item => item.category === selectedCategory);

  const sortedNews = [...filteredNews].sort((a, b) =>
    sortOrder === 'desc'
      ? new Date(b.dateSort).getTime() - new Date(a.dateSort).getTime()
      : new Date(a.dateSort).getTime() - new Date(b.dateSort).getTime()
  );

  const dotted = (iso: string) => iso.replace(/-/g, '.');

  useEffect(() => {
    updateSEO({
      title: 'News & Updates | Japan Butler Association',
      description: 'Stay informed with the latest from Japan Butler Association and the butler industry. Read announcements, certification updates, seminar reports, and international exchange activities. Updated regularly with butler news.',
      keywords: 'butler news,butler industry,hospitality news,butler association news,butler updates,butler events',
      path: '/en/news'
    });
  }, []);

  return (
    <Layout>
      <title>News & Updates | Japan Butler Association</title>
      <meta name="description" content="Stay informed with the latest from Japan Butler Association and the butler industry. Read announcements, certification updates, seminar reports, and international exchange activities. Updated regularly with butler news." />
      <link rel="canonical" href="https://butler-association.jp/en/news" />
      <link rel="alternate" hrefLang="ja" href="https://butler-association.jp/news" />
      <link rel="alternate" hrefLang="en" href="https://butler-association.jp/en/news" />

      {/* ===== Hero (navy, editorial) ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-25"
          style={{ backgroundImage: `url('/images/generated/jba-fs-104-news.webp')` }}
        ></div>
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(26,41,66,0.72),rgba(10,12,14,0.86))]"></div>
        <div className="relative z-10 max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-20 sm:py-24 lg:py-28 text-left">
          <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.34em] text-xs sm:text-[13px] text-[#d7b779]">News &amp; Updates</span>
          <div className="w-14 h-px bg-[#a38e65] my-5"></div>
          <h1 className="jba-display font-normal text-white text-[clamp(28px,3.4vw,44px)] leading-[1.35] tracking-[0.04em] max-w-3xl">
            The Present of Butler Culture<br className="hidden sm:block" />News &amp; Updates
          </h1>
          <p className="mt-6 font-['Noto_Serif_JP',serif] text-base sm:text-lg leading-[1.95] text-[#e7e2d8]/95 max-w-3xl">
            From the currents of butler service at the world&rsquo;s luxury hotels to the fusion of technology and hospitality, and reports on association activities. We deliver the latest developments in the butler industry, always with verified sources.
          </p>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== Filter (category) + Sort ===== */}
      <section className="bg-white border-b border-[#e2ddd2]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-10">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.24em] text-[11px] text-[#8f7a56] mb-3">Category</span>
              <div className="flex flex-wrap gap-2 sm:gap-2.5">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`shrink-0 whitespace-nowrap border px-4 py-2 text-[13px] tracking-[0.04em] font-['Noto_Serif_JP',serif] transition-colors duration-300 cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-[#1a2942] text-[#f8f6f0] border-[#1a2942]'
                        : 'bg-white text-[#8f7a56] border-[#a38e65]/60 hover:bg-[#f8f6f0]'
                    }`}
                  >
                    {category.label}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.24em] text-[11px] text-[#8f7a56] mb-3 lg:text-right">Sort</span>
              <div className="flex gap-2 sm:gap-2.5">
                <button
                  onClick={() => setSortOrder('desc')}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap border px-4 py-2 text-[13px] tracking-[0.04em] font-['Noto_Serif_JP',serif] transition-colors duration-300 cursor-pointer ${
                    sortOrder === 'desc'
                      ? 'bg-[#1a2942] text-[#f8f6f0] border-[#1a2942]'
                      : 'bg-white text-[#8f7a56] border-[#a38e65]/60 hover:bg-[#f8f6f0]'
                  }`}
                >
                  <i className="ri-arrow-down-line"></i>Newest
                </button>
                <button
                  onClick={() => setSortOrder('asc')}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap border px-4 py-2 text-[13px] tracking-[0.04em] font-['Noto_Serif_JP',serif] transition-colors duration-300 cursor-pointer ${
                    sortOrder === 'asc'
                      ? 'bg-[#1a2942] text-[#f8f6f0] border-[#1a2942]'
                      : 'bg-white text-[#8f7a56] border-[#a38e65]/60 hover:bg-[#f8f6f0]'
                  }`}
                >
                  <i className="ri-arrow-up-line"></i>Oldest
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== News list (editorial rows: date + fixed-width category chip + title + Read ->) ===== */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="border-t border-[#e2ddd2]">
            {sortedNews.map((news) => (
              <Link
                key={news.id}
                to={news.link}
                className="group flex items-center gap-4 sm:gap-6 py-5 border-b border-[#e2ddd2] hover:bg-[#f8f6f0]/60 transition-colors duration-300"
              >
                <span className="font-['Playfair_Display',serif] italic text-[#8f7a56] text-sm shrink-0 w-[76px] sm:w-[100px]">{dotted(news.dateSort)}</span>
                <span className="shrink-0 whitespace-nowrap border border-[#a38e65]/60 text-[#8f7a56] text-[11px] tracking-[0.04em] py-1 w-[120px] text-center">{news.categoryLabel}</span>
                <h3 className="flex-1 min-w-0 jba-display font-normal text-[#1a2942] text-[15px] sm:text-lg leading-[1.6] tracking-[0.01em] group-hover:text-[#8f7a56] transition-colors truncate sm:whitespace-normal">{news.title}</h3>
                <span className="hidden sm:inline-flex items-center gap-1.5 shrink-0 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56]">Read <span className="text-[#a38e65] group-hover:translate-x-1 transition-transform inline-block">&rarr;</span></span>
              </Link>
            ))}
          </div>

          {sortedNews.length === 0 && (
            <div className="text-center py-16 sm:py-20">
              <h3 className="text-xl sm:text-2xl jba-display font-medium text-[#1a2942] mb-3">No News Found</h3>
              <p className="text-base text-[#666] font-['Noto_Serif_JP',serif]">Please try a different category.</p>
            </div>
          )}

          <div className="text-center mt-14">
            <a href="/en" className={BTN08_ON_LIGHT}>Back to Home</a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
